<template>
  <div class="weBox">
    <div class="self">
      <div class="weTitle">
        {{
          store.state.language == "cn"
            ? "无锡执行派公司简介"
            : "Wuxi Powerfun company profile"
        }}
      </div>
      <img src="@/assets/images/背景文字2.png" class="bgcfont" alt="" />
      <div class="innerList">
        <div
          class="innerItem"
          :id="`innerItem${index}`"
          v-for="(item, index) in list"
          v-bind:key="item.id"
        >
          <div class="Title">
            {{ item.year }} <span class="secTitle"> {{ store.state.language == "cn" ? '年' : 'YEAR' }}</span>
          </div>
          <div class="newsInner">
            {{ store.state.language == "cn" ? item.title : item.titleEn }}
          </div>
          <div class="link">
            <div class="linkmore" :id="`linkmore${index}`"></div>
          </div>
        </div>
      </div>
      <div class="address" v-if="store.state.language == 'cn'">
        <!-- {{ store.state.language == "cn" ? item.title : item.titleEn }} -->
        地址：江苏省无锡市新吴区珠江路67号8栋9层<br />
        微信：impowerfun<br />
        邮箱：service@powerfun.com
      </div>
      <div class="address" v-if="store.state.language != 'cn'">
        Add: 9th Floor, Building 8, No.67 Zhujiang Road, Xinwu District, Wuxi
        City, Jiangsu Province <br />
        Wechat: impowerfun <br />
        Email: service@powerfun.com
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { ref, onMounted, watch, computed, nextTick } from "vue";
import products from "@/assets/json/products.json";
const store = useStore();

var list = ref(products.profile);

const changeAll = async () => {
  await nextTick();
  list.value.forEach((e, index) => {
    scrollToElement(index);
  });
};

const _language = computed(() => {
  return store.state.language;
});
watch(_language, () => {
  changeAll();
});

const scrollToElement = (id) => {
  // var num = !lastBool ? 44 : 20;
  var a = document.getElementById(`innerItem${id}`);
  let fontSize = document.documentElement.style.fontSize;
  console.log(fontSize)
  var num = 8;
  if(store.state.isPc){
    num = 16
  }
  var b = document.getElementById(`linkmore${id}`);
  b.style.height = `${(a.offsetHeight)/num + 4 - 1.3825}rem`;
};

onMounted(() => {
  changeAll();
});
</script>
<!-- getImagePath('软件图片.png') -->
<style lang="scss" scoped>
.weBox {
  width: 80%;
  max-width: 75rem;
  margin: 0 auto;
  padding-top: 1.5rem;
  min-width: 42.75rem;
  position: relative;
  min-height: calc(100vh - 12.125rem);

  .bgcfont {
    position: absolute;
    z-index: 0;
    width: 6.8125rem;
    height: 74.5rem;
    top: 1.875rem;
    left: -4%;
  }

  .weTitle {
    font-family: SourceHanSansCN-Bold;
    font-size: 2.5625rem;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 3rem;
    font-weight: 700;
  }
  .innerList {
    padding: 1.5rem;

    .innerItem {
      // width: ;
      position: relative;
      width: 100%;
      height: auto;
      margin-bottom: 4rem;
      .Title {
        font-family: GenSenRoundedTW-B;
        font-size: 3.375rem;
        color: #ff000d;
        letter-spacing: 0;
        line-height: 3.375rem;
        font-weight: 700;
        margin-left: 1.25rem;
        .secTitle {
          font-family: SourceHanSansCN-Medium;
          font-size: 1.125rem;
          color: #ff000d;
          letter-spacing: 0;
          font-weight: 500;
        }
      }
      .newsInner {
        font-family: SourceHanSansCN-Regular;
        font-size: 1.5rem;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 1.625rem;
        font-weight: 400;
        margin-left: 1.25rem;
      }

      .link {
        width: 0.8125rem;
        height: 0.8125rem;
        border: 0.25rem solid #ff000d;
        border-radius: 50%;
        position: absolute;
        top: 1.125rem;
        left: -1rem;
        .linkmore {
          width: 0.0625rem;
          height: calc(100% + 2.75rem);
          background-color: #ff000d;
          position: absolute;
          left: 0.375rem;
          top: 1.0625rem;
        }
      }
    }
  }

  .address {
    width: 100%;
    max-width: 75rem;
    min-width: 43.375rem;
    background-color: #99999999;
    border-radius: 0.875rem;
    font-family: SourceHanSansCN-Regular;
    font-size: 1.375rem;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 1.875rem;
    font-weight: 400;
    box-sizing: border-box;
    padding: 2rem;
    position: relative;
    z-index: 5;
    margin-bottom: 3rem;
  }
}
</style>
